import ModernTvIcon from '@/components/Icons/ModernTv';
import { useAppSelector } from '@/store/hooks';
import { selectForecasterChannels } from '@/store/selectors/forecaster.selectors';
import { Radio, RadioGroup } from '@mui/material';
import Paper from '@mui/material/Paper';
import { Controller, useFormContext } from 'react-hook-form';
import ChannelItem from './ChannelItem';

const Channels = () => {
  const { control } = useFormContext();
  const currentChannels = useAppSelector(selectForecasterChannels);

  return (
    <Paper className='col-span-3 p-4 print:p-[10px] break-after-page'>
      <div className='flex flex-col gap-2'>
        <div className='flex items-center relative'>
          <ModernTvIcon />
          <p className='ml-2 text-[#2E2C34] text-[18px] font-semibold'>Channels</p>
        </div>
        <Controller
          control={control}
          name='currentChannel'
          render={({ field }) => (
            <RadioGroup
              {...field}
              row
              sx={{ display: 'flex', justifyContent: 'space-between', gap: '12px', minHeight: '80px' }}
            >
              {currentChannels.map(channel => (
                <Radio
                  sx={{ height: '80px', padding: 0, flex: 1 }}
                  value={channel.id}
                  key={channel.title}
                  checkedIcon={<ChannelItem {...channel} checked />}
                  icon={<ChannelItem {...channel} />}
                  disableRipple
                />
              ))}
            </RadioGroup>
          )}
        />
      </div>
    </Paper>
  );
};

export default Channels;
